import { IdentityMode } from 'type/Identity'

export type Turn = 0 | 90 | 180 | 270
export type Photo = 'selfie' | 'full' | 'simple'
export type Share = 'looky' | 'telegram' | 'whatsapp'
export type Close = 'min' | 'close'
export type TryOnIconType = 'hang' | 'dress' | 'closet'

export type TryOnBody = 'base' | 'extended' | 'detailed'
export const BODY: TryOnBody[] = ['base', 'extended', 'detailed']

export type Measurements = 'height' | 'shoulders' | 'bust' | 'waist' | 'hips' | 'legLength'
export const MEASUREMENTS_DEFAULT: Measurements[] = ['height', 'bust', 'waist', 'hips']

export type Meta = {
  location?: string
  hash?: string
  self?: boolean
  selfie?: boolean
}

export type FontSettings = {
  link?: string
  family?: string
}

export type EmailBannerSettings = {
  agreement?: string
  delay?: number
  description?: string
  on?: boolean
  thanks?: string
  timeout?: number
  title?: string
  type?: 'email' | 'phone'
}

export type SelfiesSettings = {
  on?: boolean
  male?: string[]
  female?: string[]
}

export type LikesSettings = {
  on?: boolean
  feedback?: boolean
}

export type ColorSettings = {
  text?: string
  primary?: string
  background?: string

  background_soft?: string
  background_hover?: string
  body_shape_color?: string

  collapse_button?: string
  collapse_button_text?: string
}

export type Footer = {
  on?: boolean
  by?: string
  url?: string
}

export type Icon = {
  type?: TryOnIconType
  url?: string
}

export type WindowOptions = {
  product_id?: string
  try_on_combo_only?: boolean
  group?: string
}

export type Theme = 'auto' | 'light' | 'dark'

export type Options = {
  test?: boolean
  access?: string
  body?: TryOnBody | TryOnBody[]
  measurements?: Measurements[]
  profile_photo?: Photo[]
  share?: Share[]
  basic?: boolean
  boutique?: boolean
  buy_single?: boolean
  buy_combo?: boolean
  buy_title?: string
  utm_buy?: string
  camera?: boolean
  client?: string
  collapse_button_type?: 'icon' | 'text' | string
  color?: ColorSettings
  color_dark?: ColorSettings
  combine?: boolean
  company?: string
  delete_allowed?: boolean
  email?: EmailBannerSettings
  external?: boolean
  font?: FontSettings
  footer?: boolean | Footer
  icon?: Icon
  qr_photo?: boolean
  gender?: 'male' | 'female'
  avatar_gender?: 'female' | 'male'
  vendor?: string
  gemini_model?: string
  hide_name_for_en?: boolean
  hide_when_no_limit?: boolean
  inline?: string
  lang?: string
  likes?: LikesSettings
  manager?: string
  position?: string
  preview?: boolean
  product?: string
  selfies?: SelfiesSettings
  bodies?: SelfiesSettings
  shop?: string
  single_profile?: boolean
  show_clothing_sizes?: boolean
  stand?: boolean
  telegram?: string
  theme?: Theme
  tsum?: boolean
  turn?: number
  user?: string
  video?: boolean
  close?: Close
  window?: WindowOptions
  ws?: string
  combine_full?: boolean
  single_gen?: boolean
  safeAreaTop?: number
  safeAreaBottom?: number
  webview?: number
}

export type OpenParams = {
  item?: string
  favorites?: boolean
  profile?: boolean
  combo_item_id?: string
  test?: boolean
  autostart?: boolean
}

export type ItemId = {
  item: string
  group?: string
  limit?: boolean
}

export type ItemParams = {
  item?: ItemId | string
  callback_id?: string
}

export type ItemLookup = {
  item_id?: string
  group_id?: string
  limit?: boolean
}

export function extractItemLookup(item: ItemId | string | undefined): ItemLookup {
  if (!item) return {}
  if (typeof item === 'string') return { item_id: item }
  const item_id = item.item || undefined
  const group_id = item.group || undefined
  const limit = item.limit || undefined
  return { item_id, group_id, limit }
}

function extractBody(product: Options): TryOnBody[] {
  const { body } = product
  if (!body) return BODY
  if (typeof body === 'string') {
    if (body === 'base') return ['base']
    if (body === 'extended') return ['base', 'extended']
    return BODY
  }
  if (!body.length) return BODY
  return body
}

function getBodyMode(value: TryOnBody): IdentityMode {
  if (value === 'base') return 0
  else if (value === 'extended') return 1
  else if (value === 'detailed') return 2
  else return 0
}

export function extractModes(product: Options): IdentityMode[] {
  const body = extractBody(product)
  return body.map(getBodyMode)
}
